import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0a0f0a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-star-fill text-[#d4af37] text-2xl"></i>
              </div>
              <span className="text-white font-bold text-xl tracking-widest uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>Rheinmetall</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('footer_desc')}
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-telegram-fill', href: '#' },
                { icon: 'ri-whatsapp-fill', href: '#' },
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-twitter-x-fill', href: '#' },
              ].map((social, i) => (
                <a key={i} href={social.href} rel="nofollow" className="w-9 h-9 flex items-center justify-center border border-white/15 rounded-lg text-white/50 hover:text-[#d4af37] hover:border-[#d4af37]/40 transition-all duration-200 cursor-pointer">
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white/60 text-xs tracking-widest uppercase mb-4 font-medium">{t('footer_company')}</div>
            <div className="flex flex-col gap-2.5">
              {[
                { labelKey: 'footer_about',      id: 'about' },
                { labelKey: 'footer_history',    id: 'about' },
                { labelKey: 'footer_production', id: 'weapons' },
                { labelKey: 'footer_news',       id: 'about' },
              ].map((item, i) => (
                <button key={i} onClick={() => scrollTo(item.id)} className="text-white/40 hover:text-[#d4af37] text-sm text-left transition-colors duration-200 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t(item.labelKey)}
                </button>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white/60 text-xs tracking-widest uppercase mb-4 font-medium">{t('footer_investors')}</div>
            <div className="flex flex-col gap-2.5">
              {[
                { labelKey: 'footer_plans',      id: 'calculator' },
                { labelKey: 'footer_calculator', id: 'calculator' },
                { labelKey: 'footer_docs',       id: 'contacts' },
                { labelKey: 'footer_faq',        id: 'contacts' },
              ].map((item, i) => (
                <button key={i} onClick={() => scrollTo(item.id)} className="text-white/40 hover:text-[#d4af37] text-sm text-left transition-colors duration-200 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t(item.labelKey)}
                </button>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white/60 text-xs tracking-widest uppercase mb-4 font-medium">{t('footer_products')}</div>
            <div className="flex flex-col gap-2.5">
              {[
                { labelKey: 'footer_armor',     id: 'weapons' },
                { labelKey: 'footer_artillery', id: 'weapons' },
                { labelKey: 'footer_ammo',      id: 'weapons' },
                { labelKey: 'footer_air',       id: 'weapons' },
              ].map((item, i) => (
                <button key={i} onClick={() => scrollTo(item.id)} className="text-white/40 hover:text-[#d4af37] text-sm text-left transition-colors duration-200 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {t(item.labelKey)}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p className="text-white/25 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>{t('footer_rights')}</p>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            <a href="#" rel="nofollow" className="text-white/25 hover:text-white/50 text-xs transition-colors cursor-pointer">{t('footer_privacy')}</a>
            <a href="#" rel="nofollow" className="text-white/25 hover:text-white/50 text-xs transition-colors cursor-pointer">{t('footer_terms')}</a>
          </div>
        </div>

        <div className="mt-6 p-4 bg-white/2 border border-white/5 rounded-xl">
          <p className="text-white/20 text-xs text-center leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('footer_disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;